import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from '../../components/Footer'
import './Home.css'
import handqrcodescanner from '../../assets/hand-scanning-qr-code-restaurant 1.png'
import Pos from '../../assets/young-hostess-standing-near-cash-register 1.png'
import DeliveryManagement from '../../assets/Delivery Management.jpg'
import MarketplaceIntegration from '../../assets/Marketplace Integration.jpg'
import WorkPersonImage from '../../assets/close-up-man-working-with-laptop 1.png'
import WorkingImage1 from '../../assets/working-image-1.png'
import WorkingImage2 from '../../assets/working-image-2.png'
import WorkingImage3 from '../../assets/working-image-3.png'
import howFleetOrderWorks from '../../assets/how-fleetorder-works-image.png'
import RazapayImage from '../../assets/razorpay-image.png'
import SemlessImage from '../../assets/samless-image-1.png'
import SemlessImage2 from '../../assets/swiggy-semless-image.png'
import SemlessImage3 from '../../assets/zomato-semless-image.jpg'
import swiggyicon from '../../assets/swiggy-icon.png'
import zamotoicon from '../../assets/zomato-icon.png'
import ServingImage1 from '../../assets/serving-image-1.jpg'
import ServingImage2 from '../../assets/backery-image-home.jpg'
import ServingImage3 from '../../assets/hotel-image-home.jpg'
import ServingImage4 from '../../assets/startup-image-home.jpg'
import trustedLogo1 from '../../assets/trusted-logo-6.png'
import trustedLogo2 from '../../assets/trusted-logo-2.png'
import trustedLogo3 from '../../assets/trusted-logo-3.png'
import trustedLogo6 from '../../assets/trusted-logo-1.jpg'
import trustedLogo7 from '../../assets/trusted-logo-7.png'
import trustedLogo8 from '../../assets/tusted-logo-8.jpg'
import trustedLogo9 from '../../assets/trusted-logo-9.jpg'
import trustedLogo11 from '../../assets/trusted-logo-11.png'
import trustedLogo12 from '../../assets/trusted-logo-12.png'
import trustedLogo15 from '../../assets/trusted-logo-15.jpeg'
import trustedLogo17 from '../../assets/trusted-logo-17.png'
import trustedLogo18 from '../../assets/trusted-logo-18.jpeg'
import businessImage1 from '../../assets/business-image-1.png'
import businessImage2 from '../../assets/business-image-2.png'
import businessImage3 from '../../assets/business-image-3.png'
import businessImage4 from '../../assets/business-image-4.png'
import sendMessageImage from '../../assets/send-message-image.png'
import MessageIcon from '../../assets/message-icon-home-1.png'
import LocationIcon from '../../assets/location-icon-contactus.png'
import HomePageMainImage from '../../assets/home-page-main-image.png'
import { Chrono } from "react-chrono";
import { TypeAnimation } from 'react-type-animation';
import { Slider } from 'react-tech-slider';

const cards = [
    {
        image: ServingImage1,
        title: "Food & Beverage",
        content: "A robust restaurant management system designed to streamline billing, manage inventory in real-time, and track customer orders efficiently. Ideal for dine-in, takeaway, and delivery services, this system ensures accuracy, reduces waste, and enhances customer satisfaction.",
        link: "/products/fleet-eats"
    },
    {
        image: ServingImage2,
        title: "Retail",
        content: "An all-in-one Point of Sale (POS) system designed to simplify and optimize business operations through advanced features such as barcode scanning, real-time inventory updates, customer management, and multi-channel sales support. Tailored for restaurants, cafés, and retail businesses looking to enhance speed, accuracy, and customer loyalty..",
        link: "/products/fleet-mart"
    },
    {
        image: ServingImage3,
        title: "Hotels & Stays",
        content: "A powerful, all-in-one billing system designed for restaurants, hotels, and cafes — seamlessly integrating inventory management, order tracking, room management, customer engagement, and advanced POS features to elevate operational efficiency.",
        link: "/products/fleet-stay"
    },
    {
        image: ServingImage4,
        title: "Corporates",
        content: "Our billing system is built to scale effortlessly as your business evolves — whether you're operating a single outlet or expanding into a multi-location franchise. Designed with flexibility and future growth in mind, the system adapts to your changing requirements without costly upgrades or downtime.",
        link: "/products/fleet-office"
    }
];



function Home() {
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeView, setActiveView] = useState('contact');

    const sectionRefs = useRef([]);
    const sectionRef = useRef(null);

    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const index = Number(entry.target.dataset.index);
                        setActiveIndex(index);
                    }
                });
            },
            {
                threshold: 0.6,
            }
        );

        sectionRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

    }, []);

    const [formData, setFormData] = useState({
        name: "",
        product: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        const phoneNumber = "+917386616587";
        const { name, product } = formData;

        const whatsappMessage = `Hey, I am ${name}.\n\nI am interested in ${product} POS.\n\nLooking forward to a demo!`;

        const encodedMessage = encodeURIComponent(whatsappMessage);

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        window.open(whatsappUrl, "_blank");
        setFormData({
            name: "",
            product: "",
        });
    };


    const tustedLogos = [
        {
            id: 1,
            img: trustedLogo1,
            className: 'logo-img',
        },
        {
            id: 2,
            img: trustedLogo18,
            className: 'logo-img',
        },
        {
            id: 3,
            img: trustedLogo17,
            className: 'logo-img'
        },
        {
            id: 4,
            img: trustedLogo11,
            className: 'logo-img'
        },
        {
            id: 5,
            img: trustedLogo15,
            className: 'logo-img'
        },
        {
            id: 6,
            img: trustedLogo8,
            className: 'logo-img'
        },
        {
            id: 7,
            img: trustedLogo2,
            className: 'logo-img'
        },
        {
            id: 8,
            img: trustedLogo3,
            className: 'logo-img'
        },
        {
            id: 9,
            img: trustedLogo6,
            className: 'logo-img'
        },
        {
            id: 10,
            img: trustedLogo7,
            className: 'logo-img'
        },
        {
            id: 11,
            img: trustedLogo9,
            className: 'logo-img'
        },
        {
            id: 12,
            img: trustedLogo12,
            className: 'logo-img'
        }
    ]


    return (
        <>
            <Navbar />
            <div className="home-page-main-container">

                {/* <h1 className="home-page-main-heading">Smart Billing Software for Every Business</h1> */}
                <TypeAnimation
                    sequence={[
                        // Same substring at the start will only be typed out once, initially
                        'Smart Billing Software for Every Business',
                        1000, // wait 1s before replacing "Mice" with "Hamsters"
                        'It supports for Food & Beverages Stores',
                        1000,
                        'It supports for Retails',
                        1000,
                        'It supports for Resorts & Stays',
                        1000,
                        'It supports for Corporates & Startups',
                        1000
                    ]}
                    wrapper="span"
                    speed={50}
                    // style={{ fontSize: '42px', display: 'inline-block',color:"white",fontWeight:"bold",marginTop:"12px" }}
                    className="home-page-main-heading"
                    repeat={Infinity}
                />
                <p className="home-page-content">Streamline your billing process with our intelligent automation and real- time analytics</p>
                {/* <button onClick={handleRedirectToContactus} className="home-page-book-demo-button">Book Demo</button> */}
                <button className="home-page-book-demo-button" onClick={scrollToSection}>Book Demo</button>
                <img src={HomePageMainImage} alt="fleetorder-home-image" className="fleetorder-home-image" />

                <div className="solutions-main-container">
                    <div className="solutions-content-container">
                        <h1 className="solutions-main-heading">All-in-One Solutions for Your Business</h1>
                        <div className="solutions-cards-container">

                            <div className="solution-card">
                                <div className="solution-card-content-container">
                                    <h1 className="solution-main-heading">QR Scan Payments</h1>
                                    <p className="solution-sub-heading">Our system offers quick and secure QR code-based payments, making transactions seamless for your customers.</p>
                                    <p className="read-more">Read More</p>
                                </div>
                                <img src={handqrcodescanner} alt="solution-image" className="solution-image" />
                            </div>

                            <div className="solution-card">
                                <div className="solution-card-content-container">
                                    <h1 className="solution-main-heading">POS</h1>
                                    <p className="solution-sub-heading">Our powerful Point-of-Sale (POS) system provides advanced features like barcode scanning, inventory tracking, and comprehensive billing</p>
                                    <p className="read-more">Read More</p>
                                </div>
                                <img src={Pos} alt="solution-image" className="solution-image" />
                            </div>

                            <div className="solution-card">
                                <div className="solution-card-content-container">
                                    <h1 className="solution-main-heading">Delivery Management</h1>
                                    <p className="solution-sub-heading">Take control of your logistics with our integrated delivery management solution. Easily manage online orders.</p>
                                    <p className="read-more">Read More</p>
                                </div>
                                <img src={DeliveryManagement} alt="solution-image" className="solution-image" />
                            </div>

                            <div className="solution-card">
                                <div className="solution-card-content-container">
                                    <h1 className="solution-main-heading">Marketplace Integration</h1>
                                    <p className="solution-sub-heading">Expand your reach by integrating with popular online marketplaces. Sync your inventory, sales, and customer</p>
                                    <p className="read-more">Read More</p>
                                </div>
                                <img src={MarketplaceIntegration} alt="solution-image" className="solution-image" />
                            </div>

                        </div>
                    </div>
                </div>

                <div className="work-infrastructure-main-container">
                    <h1 className="work-infrastructure-main-heading"><span className="work-infrastructure-span">FleetOrder</span> Works effortlessly with your current infrastructure.</h1>
                    <div className="work-infrastructure-image-container">
                        <img src={WorkPersonImage} alt="work-person-image" className="work-person-image" />
                        <div className="working-images">
                            <img src={WorkingImage2} alt="working-image-1" className="working-image" />
                            <p className="working-text">Works on any Screens</p>
                        </div>
                        <div className="working-images">
                            <img src={WorkingImage1} alt="working-image-1" className="working-image" />
                            <p className="working-text">Keyboard / touchscreen view</p>
                        </div>
                        <div className="working-images">
                            <img src={WorkingImage3} alt="working-image-1" className="working-image" />
                            <p className="working-text">Works on major Operating systems</p>
                        </div>
                    </div>
                </div>

                <div className="serving-industry-main-container">
                    <h1 className="serving-industry-main-heading">Serving Every Industry, Selling Everywhere</h1>

                    {/* <div className="serving-images-container">
                        <img src={ServingImage1} className="serving-image" alt="serving-image" />
                        <div className="serving-images-content-container">
                            <h1 className="serving-image-title">Food & Beverage</h1>
                            <p className="serving-image-content">Complete restaurant billing with inventory management and order tracking.</p>
                            <button className="serving-button">Know More</button>
                        </div>
                    </div> */}

                    <div className="split-scroll-container">

                        <div className="image-panel">
                            <img src={cards[activeIndex].image} alt="card visual" className="split-image" />
                        </div>


                        <div className="content-panel">
                            {cards.map((card, index) => (
                                <div
                                    key={index}
                                    className="content-section"
                                    ref={(el) => (sectionRefs.current[index] = el)}
                                    data-index={index}
                                >
                                    <h2 className="content-panel-title">{card.title}</h2>
                                    <p className="content-panel-description">{card.content}</p>
                                    {/* <button className="content-button">Know More</button> */}
                                    <button
                                        className="content-button"
                                        onClick={() => navigate(card.link)}
                                    >
                                        Know More
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>

                <div className="trust-fleetorder-main-container">
                    <h1 className="trust-fleetorder-main-heading">
                        Why Businesses Trust <span className="work-infrastructure-span">FleetOrder</span>
                    </h1>
                    <p className="trust-fleetorder-content">
                        From fleet owners to customers and franchises, discover how FleetOrder transforms every aspect of the delivery ecosystem
                    </p>

                    <Chrono mode="VERTICAL_ALTERNATING" theme={{
                        primary: 'orange',
                        secondary: 'white',
                        cardBgColor: 'white',
                        cardForeColor: 'orange',
                        titleColor: 'orange',
                    }} disableNavOnKey hideControls className="chrono-container">
                        <div className="project-cards">
                            <img src={businessImage1} className="project-image" alt="project-image" />
                            <div className="project-content">
                                <p className="project-year">Setup is Simple</p>
                                <p className="project-info">FleetOrder  is easy to use - so you can spend more time with your guests, and less time training staff.</p>
                            </div>
                        </div>

                        <div className="project-cards">
                            <img src={businessImage2} className="project-image" alt="project-image" />
                            <div className="project-content">
                                <p className="project-year">24/7 Dedicated Account Support</p>
                                <p className="project-info">Help is always at hand with our round-the-clock support to resolve your queries and concerns.</p>
                            </div>
                        </div>

                        <div className="project-cards">
                            <img src={businessImage3} className="project-image" alt="project-image" />
                            <div className="project-content">
                                <p className="project-year">Continuous Updates</p>
                                <p className="project-info">The world of commerce is constantly changing and our tools are constantly synced with these developments.</p>
                            </div>
                        </div>

                        <div className="project-cards">
                            <img src={businessImage4} className="project-image" alt="project-image" />
                            <div className="project-content">
                                <p className="project-year">99.5% uptime guaranteed</p>
                                <p className="project-info">Our team is committed to helping you manage operations smoothly and keep them up and running, always.</p>
                            </div>
                        </div>

                    </Chrono>

                    <h1 className="trust-fleetorder-main-heading">
                        Ready to Transform Your Business?
                    </h1>
                    <p className="trust-fleetorder-content">
                        Join thousands of businesses already using FleetOrder to streamline their operations
                    </p>
                    <button className="started-button" onClick={scrollToSection}>Get Started Today</button>
                </div>



                <div className="how-fleet-order-works-main-container">
                    <h1 className="how-fleetorder-works-heading">How <span className="work-infrastructure-span">FleetOrder</span> Works</h1>
                    <img src={howFleetOrderWorks} className="how-fleetorder-works-image" alt="how-fleetorder-works-image" />
                </div>

                <div className="samless-integration-main-container">
                    <h1 className="samless-integration-heading">Seamless Integrations for Your Business</h1>

                    <div className="samless-integration-card-container">
                        <div>
                            <img src={RazapayImage} className="samless-logos" alt="sameless-image" />
                            <p className="samless-points main-point">Accept payments the smarter way with Razorpay. From UPI to credit cards, your customers get multiple payment options while you enjoy instant settlements and secure transactions.</p>
                            <p className="samless-points">✅ Multiple payment methods (UPI, Cards, Wallets) </p>
                            <p className="samless-points">✅ Instant & secure transactions</p>
                            <p className="samless-points">✅ Automated settlement tracking</p>
                        </div>
                        <div>
                            <img src={SemlessImage} className="semless-image" alt="semless-image" />
                        </div>
                    </div>

                    <div className="samless-integration-card-container" style={{ gap: "24px" }}>
                        <div style={{ order: 1, display: "flex", flexDirection: "column", marginRight: "24px" }}>
                            <div>
                                <img src={swiggyicon} className="samless-logos-swiggy" alt="sameless-image" />
                                <span className="work-infrastructure-span-swiggy">Swiggy</span>
                            </div>
                            <p className="samless-points main-point">Seamlessly connect your restaurant billing system with Swiggy. Get real-time order syncing, faster kitchen updates, and instant billing — all from one dashboard.</p>
                            <p className="samless-points">✅ Auto-sync orders to POS</p>
                            <p className="samless-points">✅ Faster order processing</p>
                            <p className="samless-points">✅ Unified reporting for dine-in + delivery</p>
                        </div>
                        <div style={{ order: 0 }}>
                            <img src={SemlessImage2} className="semless-image" alt="semless-image" />
                        </div>
                    </div>

                    <div className="samless-integration-card-container">
                        <div>
                            <div className="zomato-button">
                                <img src={zamotoicon} className="samless-icon" alt="samless-zomato-image" />
                            </div>
                            <p className="samless-points main-point">Boost your online orders with Zomato integration. Manage menu, pricing, and customer orders directly from your billing software without juggling multiple devices.</p>
                            <p className="samless-points">✅ Centralized menu management</p>
                            <p className="samless-points">✅ Real-time order notifications</p>
                            <p className="samless-points">✅ Simplified billing & tracking</p>
                        </div>
                        <div>
                            <img src={SemlessImage3} className="semless-image" alt="semless-image" />
                        </div>
                    </div>

                </div>

                <div className="trusted-companies-main-container">
                    <h3 className="trusted-comapanies-heading">Trusted by 500+ Businesses</h3>
                    <p className="trusted-companies-content">Join thousands of satisfied customers worldwide</p>
                    {/* <div className="logos-scroll">
                            <div className="logos-group">
                                {tustedLogos.map((logo, idx) => (
                                    <img key={`logo-${idx}`} src={logo} alt={`logo-${idx}`} className="logo-img" />
                                ))}
                            </div>
                        </div> */}
                    <Slider brandsList={tustedLogos}
                        borderWidth={2}
                        borderColor="black"
                        backgroundColor="black"
                        iconWidth={6}
                        isPlay={true}
                        pauseOnHoverActive={true}
                        durationMs={20000} />

                </div>

                <div className="happy-clients-main-container">
                    <h1 className="happy-client-heading">Hear from Our Happy Clients</h1>
                    <p className="happy-clients-content">Real stories, real growth.</p>
                    <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/QbfKdXElFeE"
                        title="YouTube video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="video-mobile-view"
                    ></iframe>
                </div>


                <div className="contact-form-main-container" ref={sectionRef}>
                    <div className="contact-form-content-container">
                        <div className="contactus-buttons-container">
                            <button
                                className={`contactus-form-buttons ${activeView === 'contact' ? 'active' : ''}`}
                                onClick={() => setActiveView('contact')}
                            >
                                <img src={MessageIcon} alt="message-icon" className="contact-form-icons" />
                                Contact Form
                            </button>

                            <button
                                className={`contactus-form-buttons ${activeView === 'location' ? 'active' : ''}`}
                                onClick={() => setActiveView('location')}
                            >
                                <img src={LocationIcon} alt="location-icon" className="contact-form-icons" />
                                Location
                            </button>
                        </div>



                        {activeView === 'contact' ? (
                            <>
                                <img src={sendMessageImage} alt="send-message-icon" className="send-message-icon" />
                                <h1 className="send-message-heading">Book a Demo</h1>
                                <p className="send-message-description">
                                    Fill out the form below and connect us instantly.
                                </p>

                                <form className="send-message-form-main" onSubmit={handleWhatsAppSubmit}>
                                    <div className="send-message-form">
                                        <div className="input-container">
                                            <label>Full Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="John Doe"
                                                className="input-field"
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* <div className="input-container">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john@example.com"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div> */}
                                    </div>

                                    <div className="input-container">
                                        <label>Product</label>
                                        <select
                                            name="product"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select a product</option>
                                            <option value="Fleet Eats">Fleet Eats</option>
                                            <option value="Fleet Mart">Fleet Mart</option>
                                            <option value="Fleet Stay">Fleet Stay</option>
                                            <option value="Fleet Office">Fleet Office</option>
                                        </select>
                                    </div>

                                    {/* <div className="input-container">
                                    <label>Message</label>
                                    <textarea
                                        name="message"
                                        placeholder="Type your message here..."
                                        className="input-field"
                                        rows="6"
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div> */}

                                    <button type="submit" className="send-message-button">
                                        Connect Us
                                    </button>
                                </form>
                            </>
                        ) : (
                            // Location View
                            <div className="map-image-background">
                                <div className="reach-out-cards-container">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.9578505414875!2d78.52185867368995!3d17.413810302046286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99cd9d705bf5%3A0x3047f24f1c947e3d!2sOsmania%20TBI!5e0!3m2!1sen!2sin!4v1761284799369!5m2!1sen!2sin"
                                        width="600"
                                        height="450"
                                        allowFullScreen
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="Osmania TBI Map"
                                        style={{ border: 0 }}
                                    ></iframe>
                                </div>
                            </div>

                        )}

                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}

export default Home